import React from 'react';

import DownloadIcon from '@assets/img/icons/download-fullfilled-primary.svg';
import LinkIcon from '@assets/img/icons/link.svg';
import { makeMuiStyles, useCommonStyles } from '@styles/index';
import clsx from 'clsx';
import Color from 'color';

const useStyles = makeMuiStyles((theme, common) => ({
  statusName: {
    ...common.middleText,
    lineHeight: '21px',
  },
  message: {
    ...common.textGray500,
    ...common.smallerText,
    lineHeight: '18px',
  },
  textNext: {
    color: Color(theme.palette.primary.main).alpha(0.4).toString(),
  },
}));

interface BookingStatusItemProps {
  name: string;
  link?: string | null;
  attached_file?: { url: string } | null;
  message?: string | null;
  noWrap?: boolean;
  color?: 'default' | 'primary' | 'error' | 'next';
}

export const BookingStatusItem: React.FC<BookingStatusItemProps> = (props) => {
  const { name, link, attached_file, message, color, noWrap } = props;
  const classes = { ...useStyles(), ...useCommonStyles() };
  return (
    <>
      <div className={clsx(classes.flexInline, noWrap && classes.whitespacePre)}>
        <div
          className={clsx(
            classes.statusName,
            color === 'error' && classes.textErrorImportant,
            color === 'primary' && classes.textPrimaryImportant,
            color === 'next' && classes.textNext,
          )}
        >
          {name}
        </div>
        &nbsp;
        {link && (
          <a href={link} target="_blank">
            <img src={LinkIcon} alt="tick" />
          </a>
        )}
        {attached_file && (
          <a
            className={classes.baseButton}
            target="_blank"
            rel="noreferrer"
            href={attached_file.url}
          >
            <img src={DownloadIcon} alt="tick" />
          </a>
        )}
      </div>
      {message && (
        <div className={clsx(classes.message, color === 'error' && classes.textErrorImportant)}>
          {message}
        </div>
      )}
    </>
  );
};
